import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useSearchParams,
} from "react-router-dom";
import { routes } from "./router";
import { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ScrollToTop from "./assets/components/ScrollToTop";
import "./App.css";

const App = () => {
    const noqUser = localStorage.getItem("noqEventUser") || sessionStorage.getItem("noqEventUser");
    const noqUserObj = JSON.parse(noqUser);
    const [user] = useState(noqUserObj);
    const [isAuthenticated, setIsAuthenticated] = useState(Boolean(user));
    const { isLoggedInSuccess } = useSelector((state) => state.auth);
    // const [searchParams] = useSearchParams();
    // const eventId = searchParams.get("eventId");

    const handleStorageChange = () => {
        const noqUser =
            localStorage.getItem("noqEventUser") || sessionStorage.getItem("noqEventUser");
        const noqUserObj = JSON.parse(noqUser);

        if (noqUserObj || isLoggedInSuccess) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    };

    useEffect(() => {
        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <>
            <Toaster position="top-right" />
            <Router>
                <ScrollToTop />
                <Routes>
                    {routes.map((route) => {
                        return route.isPrivate ? (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={isAuthenticated ? route.element : <Navigate to="/login" />}
                            />
                        ) : (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={
                                    isAuthenticated ? <Navigate to={`/dashboard`} /> : route.element
                                }
                            />
                        );
                    })}
                </Routes>
            </Router>
            {/* <RouterProvider router={router} /> */}
        </>
    );
};

export default App;
